/**
 * Saving a file the API returned. The download is proxied rather than linked
 * because the Grid API key is server-side only, so the bytes arrive as a blob
 * and the browser has to be told to save them.
 */

/**
 * The filename Grid put on the response. Prefers RFC 5987 `filename*`, which is
 * the readable one ("Slow_Horses_Photo_060203 (c90a…).jpg"); plain `filename`
 * holds only the image id.
 */
export function filenameFromDisposition(header: string | undefined | null): string | null {
  if (!header) return null;
  const extended = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (extended) {
    try {
      return decodeURIComponent(extended[1].trim());
    } catch {
      // A malformed percent-escape must not cost the editor the download.
    }
  }
  const plain = /filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i.exec(header);
  const value = plain?.[1] ?? plain?.[2];
  return value?.trim() || null;
}

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
